import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { getMenu } from 'Shared/GTM/getMenu'
import MediaQuery from 'react-responsive'

const CategoryMenuType = props => (
  <Fragment>
    {ComposeMenuType(
      props.type,
      props.sku,
      props.path,
      props.label,
      props.enabled,
      props.handleKeyEsc
    )}
  </Fragment>
)

const ComposeMenuType = (type, sku, path, label, enabled, handleKeyEsc) => {
  switch (enabled) {
    case true:
      switch (type) {
        case 'product':
          return (
            <Link
              to={`/products/${sku}`}
              className='link-menu'
              onClick={() => {
                getMenu(true, 'home', 'clique:menu', label)
              }}
              onKeyDown={(e) => handleKeyEsc(e)}
            >
              <div className='row'>
                <div className='link-text col-auto type-product'>
                  {label}
                </div>
                <div className='link-icon col-auto d-none d-md-flex pl-0'>
                  <i className='icon icon_down icon-ssm' />
                </div>
              </div>
            </Link>
          )
        case 'external-link':
          return (
            <a
              href={`${path}`}
              className='link-menu type-external-link'
              target='_blank'
              onClick={() => {
                getMenu(true, 'home', 'clique:menu', label)
              }}
            >
              <div className='row'>
                <div className='link-text col-auto'>
                  {label}
                </div>
              </div>
            </a>
          )
        case 'internal-link':
          return (
            <Link
              onClick={() => {
                getMenu(true, 'home', 'clique:menu', label)
              }}
              to={`${path}`}
              className='link-menu txt-font-body-bold d-flex type-internal-link'
            >
              <div className='row'>
                <div className='link-text col-auto'>
                  {label}
                </div>
              </div>
            </Link>
          )

        case 'dynamic':
          return (
            <Fragment>
              <MediaQuery minWidth={768} maxWidth={1024}>
                <button
                  className='link-menu type-dynamic px-0'
                  onClick={() => {
                    getMenu(true, 'home', 'clique:menu', label)
                  }}
                  onKeyDown={(e) => handleKeyEsc(e)}
                  aria-expanded='false'
                >
                  <div className='row'>
                    <div className='link-text col-auto'>
                      {label}
                    </div>
                    <div className='link-icon col-auto d-none d-md-flex pl-0'>
                      <i className='icon icon_right icon-ssm' />
                    </div>
                  </div>
                </button>
              </MediaQuery>
              <MediaQuery minWidth={1025}>
                <button
                  className='link-menu type-dynamic'
                  onClick={() => {
                    getMenu(true, 'home', 'clique:menu', label)
                  }}
                  onKeyDown={(e) => handleKeyEsc(e)}
                  aria-expanded='false'
                >
                  <div className='row'>
                    <div className='link-text col-auto'>
                      {label}
                    </div>
                    <div className='link-icon col-auto d-none d-md-flex pl-0'>
                      <i className='icon icon_down icon-ssm' />
                    </div>
                  </div>
                </button>
              </MediaQuery>
            </Fragment>
          )
        case 'services':
          return (
            <Fragment>
              <MediaQuery minWidth={768} maxWidth={1024}>
                <button
                  className='link-menu type-services p-0'
                  onClick={() => {
                    getMenu(true, 'home', 'clique:menu', label)
                  }}
                  onKeyDown={(e) => handleKeyEsc(e)}
                  aria-expanded='false'
                >
                  <div className='row'>
                    <div className='link-text col-auto'>
                      {label}
                    </div>
                    <div className='link-icon col-auto d-none d-md-flex pl-0'>
                      <i className='icon icon_right icon-ssm' />
                    </div>
                  </div>
                </button>
              </MediaQuery>
              <MediaQuery minWidth={1025}>
                <button
                  className='link-menu type-services p-0'
                  onClick={() => {
                    getMenu(true, 'home', 'clique:menu', label)
                  }}
                  onKeyDown={(e) => handleKeyEsc(e)}
                  aria-expanded='false'
                >
                  <div className='row'>
                    <div className='link-text col-auto'>
                      {label}
                    </div>
                    <div className='link-icon col-auto d-none d-md-flex pl-0'>
                      <i className='icon icon_down icon-ssm' />
                    </div>
                  </div>
                </button>
              </MediaQuery>
            </Fragment>
          )
        case 'services-external':
          return (
            <Fragment>
              <MediaQuery minWidth={768} maxWidth={1024}>
                <button
                  className='link-menu type-services-external p-0'
                  onClick={() => {
                    getMenu(true, 'home', 'clique:menu', label)
                  }}
                  onKeyDown={(e) => handleKeyEsc(e)}
                  aria-expanded='false'
                >
                  <div className='row'>
                    <div className='link-text col-auto'>
                      {label}
                    </div>
                    <div className='link-icon col-auto d-none d-md-flex pl-0'>
                      <i className='icon icon_right icon-ssm' />
                    </div>
                  </div>
                </button>
              </MediaQuery>
              <MediaQuery minWidth={1025}>
                <button
                  className='link-menu type-services-external p-0'
                  onClick={() => {
                    getMenu(true, 'home', 'clique:menu', label)
                  }}
                  onKeyDown={(e) => handleKeyEsc(e)}
                  aria-expanded='false'
                >
                  <div className='row'>
                    <div className='link-text col-auto'>
                      {label}
                    </div>
                    <div className='link-icon col-auto d-none d-md-flex pl-0'>
                      <i className='icon icon_down icon-ssm' />
                    </div>
                  </div>
                </button>
              </MediaQuery>
            </Fragment>
          )
        case 'category':
          return (
            <Fragment>
              <MediaQuery minWidth={768} maxWidth={1024}>
                <button
                  className='link-menu type-category px-0'
                  onClick={() => {
                    getMenu(true, 'home', 'clique:menu', label)
                  }}
                  onKeyDown={(e) => handleKeyEsc(e)}
                  aria-expanded='false'
                >
                  <div className='row'>
                    <div className='link-text col-auto'>
                      {label}
                    </div>
                    <div className='link-icon col-auto d-none d-md-flex pl-0'>
                      <i className='icon icon_right icon-ssm' />
                    </div>
                  </div>
                </button>
              </MediaQuery>
              <MediaQuery minWidth={1025}>
                <button
                  className='link-menu type-category'
                  onClick={() => {
                    getMenu(true, 'home', 'clique:menu', label)
                  }}
                  onKeyDown={(e) => handleKeyEsc(e)}
                  aria-expanded='false'
                >
                  <div className='row'>
                    <div className='link-text col-auto'>
                      {label}
                    </div>
                    <div className='link-icon col-auto d-none d-md-flex pl-0'>
                      <i className='icon icon_down icon-ssm' />
                    </div>
                  </div>
                </button>
              </MediaQuery>
            </Fragment>
          )
        case 'sub-category':
          return (
            <Fragment>
              <MediaQuery minWidth={768} maxWidth={1024}>
                <button
                  className='link-menu type-sub-category px-0'
                  onClick={() => {
                    getMenu(true, 'home', 'clique:menu', label)
                  }}
                  onKeyDown={(e) => handleKeyEsc(e)}
                  aria-expanded='false'
                >
                  <div className='row'>
                    <div className='link-text col-auto'>
                      {label}
                    </div>
                    <div className='link-icon col-auto d-none d-md-flex pl-0'>
                      <i className='icon icon_right icon-ssm' />
                    </div>
                  </div>
                </button>
              </MediaQuery>
              <MediaQuery minWidth={1025}>
                <button
                  className='link-menu type-sub-category'
                  onClick={() => {
                    getMenu(true, 'home', 'clique:menu', label)
                  }}
                  onKeyDown={(e) => handleKeyEsc(e)}
                  aria-expanded='false'
                >
                  <div className='row'>
                    <div className='link-text col-auto'>
                      {label}
                    </div>
                    <div className='link-icon col-auto d-none d-md-flex pl-0'>
                      <i className='icon icon_down icon-ssm' />
                    </div>
                  </div>
                </button>
              </MediaQuery>
            </Fragment>
          )
      }
  }
}

CategoryMenuType.propTypes = {
  type: PropTypes.string,
  sku: PropTypes.string,
  path: PropTypes.string,
  label: PropTypes.string,
  enabled: PropTypes.string,
  handleKeyEsc: PropTypes.func
}

export default CategoryMenuType



// WEBPACK FOOTER //
// ./src/App/MainMenu/CategoryMenu/CategoryMenuType.js